export default __webpack_public_path__ + "static/media/sharePrototype.859f6774.webp";